<template>
  <div class="setting-auto-flow disp-scroll">
    <h2 class="title">
      <span class="mdi mdi-chart-timeline timeline"></span>
      採用フロー停止設定
    </h2>
    <div class="setting-auto-flow-table-container">
      <SettingPauseAutoFlowTable
        :pauseDaysWeek="pauseDaysWeek"
        :createPauseAutoFlowSetting="createPauseAutoFlowSetting"
        :pauseAutoFlowSettingList="pauseAutoFlowSettingList"
        :deletePauseAutoFlowSetting="deletePauseAutoFlowSetting"
        :PCTRLLOG="CTRLLOG"
      />
    </div>
    <p style="font-size: smaller; color: #666;">※上記設定は、媒体連携による応募者反映時の<br />採用フローに対してのみ有効です。</p>
  </div>
</template>

<script>
import SettingPauseAutoFlowTable from '@/components/molecules/tables/SettingPauseAutoFlowTable'
import controlLogMixin from '@/mixins/controlLogMixin'

export default {
  components: {
    SettingPauseAutoFlowTable,
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    createPauseAutoFlowSetting: {
      type: Function,
      required: true,
      default: () => null,
    },
    deletePauseAutoFlowSetting: {
      type: Function,
      required: true,
      default: () => null,
    },
    pauseDaysWeek: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      required: true,
      default: () => {},
    },
    pauseAutoFlowSettingList: {
      type: Array,
      required: true,
      default: () => [],
    }
  },
}
</script>

<style lang="scss" scoped>
.setting-auto-flow {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 50%;
  max-width: 500px;
  background: #fefefe;
  padding: 16px;
  z-index: 201;
  .title {
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 16px;
  }
  .timeline {
    margin-right: 8px;
  }
  .setting-auto-flow-table-container {
    display: flex;
    justify-content: center;
    margin-top: 16px;
    height: calc(100% - 100px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/slidemenus/SettingPauseAutoFlow.vue